import auth from "./auth";
import {createRouter, createWebHashHistory} from "vue-router";

import defaultLayout from "./layouts/defaultWithMenuAndToolbarLayout.vue";
// import normalLayout from "./layouts/simpleWithOutMenu.vue";
import simpleLayout from "./layouts/simpleLayout.vue";
import appConfig from "@/app-config";

import {loadMessages, locale} from "devextreme/localization";
import {applyLocale, isDevelopPath, setPath} from "@/utils/develop-lang";
import deMessages from "devextreme/localization/messages/de.json";
import msaMessages from "@/msa_lng.json";

function loadView(view) {
    return () => import (`./views/${view}.vue`);
}

function addRouteFromMenuItem(items) {
    if (items) {
        items.forEach((item) => {
            if (item.path && item.path !== '') {
                router.addRoute({
                    component: item.component ? loadView(item.component) : loadView(item.path.replace('/', '')),
                    name: item.path.replace('/', ''),
                    path: item.path,
                    meta: {
                        requiresAuth: true,
                        layout: defaultLayout,
                    }
                });
            }
            if (item.items) addRouteFromMenuItem(item.items);
        });
    }
}

if (!appConfig.language) appConfig.language = 'de';

loadMessages(deMessages);
loadMessages(msaMessages);
locale(appConfig.language);


if (window.location.search.indexOf("token=") > -1) {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token')
    localStorage.setItem('token', token);
    localStorage.setItem('c', '1');
} else
    localStorage.setItem('c', '0');

let version = localStorage.getItem('version');
if (version !== appConfig.version) {
    let token = localStorage.getItem('token')
    let c = localStorage.getItem('c')
    localStorage.clear();
    localStorage.setItem('token', token);
    localStorage.setItem('c', c);
    localStorage.setItem('version', appConfig.version);
}

await auth.authenticate();

let home = 'home';

if (appConfig.session_token && appConfig.menu.length === 1 && !window.location.href.includes("task-mail"))
    home = appConfig.menu[0].path;

const router = new createRouter({
    routes: [
        {
            path: "/",
            redirect: home
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: home
        },
        // {
        //     path: "/",
        //     name: "tt",
        //     meta: {
        //         requiresAuth: false,
        //         layout: normalLayout
        //     },
        //     component: loadView("cst/task/transport-orders")
        // },
        {
            path: "/home",
            name: "home",
            meta: {
                requiresAuth: true,
                layout: defaultLayout
            },
            component: loadView("home/home")
        },
        {
            path: "/authentication",
            name: "login-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Anmeldung"
            },
            component: loadView("authentication/login-form")
        },
        {
            path: "/createAccount",
            name: "create-account-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Zugang beantragen"
            },
            component: loadView("authentication/create-account/create-account-form")
        },
        {
            path: "/resetPassword",
            name: "reset-password-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Kennwort zurücksetzen"
            },
            component: loadView("authentication/reset-password/reset-password-form")
        },
        {
            path: "/changePassword",
            name: "change-password-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Kennwort ändern"
            },
            component: loadView("authentication/change-password-form")
        },
        {
            path: "/b2b",
            name: "b2b",
            meta: {
                requiresAuth: false,
                layout: simpleLayout
            },
            component: loadView("intern/basedata/origin/origin-contacts")
        },
        {
            path: "/task-mail",
            name: "task-task-mail",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Mail"
            },
            component: loadView("intern/task/task-mail")
        },
        {
            path: "/reporting/designer",
            name: "reporting/designer",
            meta: {
                requiresAuth: true,
                layout: simpleLayout
            },
            component: loadView("reporting/designer")
        }
    ],
    history: createWebHashHistory()
});

if (appConfig.menu) {
    addRouteFromMenuItem(appConfig.menu);
}

router.beforeEach((to, from, next) => {

    let version = localStorage.getItem('version');
    if (version !== appConfig.version) {
        let token = localStorage.getItem('token')
        localStorage.clear();
        localStorage.setItem('token', token);
        localStorage.setItem('version', appConfig.version);
    }

    if (from.name === 'login-form')
        addRouteFromMenuItem(appConfig.menu);

    // Develop-Views: Sprache je Screen (Standard englisch); beim Verlassen zurück auf die App-Sprache
    setPath(to.path);
    if (isDevelopPath(to.path))
        applyLocale();
    else if (isDevelopPath(from.path))
        locale(appConfig.language);

    if (to.name === "login-form" && auth.loggedIn()) {
        next({name: "home"});
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!auth.loggedIn()) {
            next({
                name: "login-form",
                query: {redirect: to.fullPath}
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
